
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.708 18.293a6.254 6.254 0 01-4.425-1.82L7.818 13.01a2.11 2.11 0 01-.623-1.51c.002-.571.226-1.106.632-1.507a2.132 2.132 0 012.998.009L14 13.174a.96.96 0 001.635-.675.95.95 0 00-.28-.68l-3.46-3.46a5.086 5.086 0 00-3.613-1.48A5.085 5.085 0 004.63 8.417a5.087 5.087 0 00-1.457 3.687c.054 2.766 2.351 5.017 5.12 5.017.495 0 .983-.07 1.453-.209a.585.585 0 11.332 1.124 6.304 6.304 0 01-1.786.258c-3.402 0-6.224-2.766-6.29-6.166a6.25 6.25 0 011.79-4.53 6.246 6.246 0 014.486-1.89 6.266 6.266 0 014.44 1.82l3.464 3.464c.404.404.626.94.624 1.511a2.116 2.116 0 01-.632 1.509 2.135 2.135 0 01-3.004-.009L9.997 10.83a.957.957 0 00-1.346-.004.948.948 0 00-.283.677.95.95 0 00.279.678l3.461 3.462a5.09 5.09 0 003.6 1.48 5.127 5.127 0 005.121-5.116 5.089 5.089 0 00-1.5-3.624 5.085 5.085 0 00-3.62-1.503 5.13 5.13 0 00-1.468.213.586.586 0 01-.335-1.123 6.327 6.327 0 011.802-.262c1.68 0 3.26.656 4.45 1.847A6.25 6.25 0 0122 12.007a6.3 6.3 0 01-6.292 6.285z","fill":"currentColor"}})])
          )
        }
      }
    